import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, TrendingUpIcon, MapPinIcon, CalendarIcon, FilmIcon, BriefcaseIcon } from 'lucide-react';
import StatisticsBar from '../components/StatisticsBar';
import SocialTrendingSection from '../components/SocialTrendingSection';
import CommunityCard from '../components/CommunityCard';
import EventCard from '../components/EventCard';
import BrandsTrustUs from '../components/BrandsTrustUs';
import PersonalizedSection from '../components/PersonalizedSection';
import SkeletonLoader from '../components/SkeletonLoader';
const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [recommendedCommunities, setRecommendedCommunities] = useState([]);
  useEffect(() => {
    // Simulate API loading
    const timer = setTimeout(() => {
      setRecommendedCommunities([{
        id: '1',
        name: 'Nairobi Tech Hub',
        description: 'A community of tech enthusiasts, developers, and entrepreneurs in Nairobi.',
        memberCount: 1200,
        location: 'Nairobi, Kenya',
        category: 'Technology',
        nextEvent: 'Coding Bootcamp, Aug 15'
      }, {
        id: '2',
        name: 'WeRun Nairobi',
        description: 'A running community that organizes weekly runs, marathons, and fitness events.',
        memberCount: 850,
        location: 'Nairobi, Kenya',
        category: 'Fitness',
        nextEvent: 'Saturday Run, Aug 12'
      }, {
        id: '3',
        name: 'Kenya Book Club',
        description: 'A book club that meets monthly to discuss various genres of books and authors.',
        memberCount: 320,
        location: 'Nairobi & Virtual',
        category: 'Books',
        nextEvent: 'Book Discussion, Aug 20'
      }, {
        id: '4',
        name: 'Kenyan Foodies',
        description: 'Explore local cuisine, restaurant reviews, and cooking events with fellow food enthusiasts.',
        memberCount: 950,
        location: 'Nationwide',
        category: 'Food',
        nextEvent: 'Food Festival, Sep 5'
      }]);
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  return <div className="flex flex-col min-h-screen" data-id="element-2250">
      {/* Hero section with gradient background - will be red/green gradient in final design */}
      <div className="p-4 pb-8 border-b border-gray-200 bg-gradient-to-r from-green-700 to-red-700" data-id="element-2251">
        <div className="max-w-3xl mx-auto text-center mb-6" data-id="element-2252">
          <h1 className="text-3xl font-bold mb-2 text-white" data-id="element-2253">Join Today!</h1>
          <h2 className="text-2xl font-bold mb-3 text-amber-200" data-id="element-2254">
            Connect with Your Kenyan Community
          </h2>
          <p className="text-white mb-6" data-id="element-2255">
            Discover, join, and actively participate in diverse communities
            across Kenya. Find your tribe, build lasting connections, and stay
            updated on events and opportunities.
          </p>
          <div className="relative mb-6" data-id="element-2256">
            <input type="text" placeholder="Find your tribe... e.g., 'hiking' or 'book clubs'" className="w-full p-3 pl-10 border border-gray-300 rounded-lg" data-id="element-2257" />
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" data-id="element-2258" />
          </div>
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-2259">
            <button className="px-3 py-1 border border-gray-300 bg-gray-200 rounded-full text-sm" data-id="element-2260">
              Running Groups
            </button>
            <button className="px-3 py-1 border border-gray-300 bg-gray-200 rounded-full text-sm" data-id="element-2261">
              Tech Meetups
            </button>
            <button className="px-3 py-1 border border-gray-300 bg-gray-200 rounded-full text-sm" data-id="element-2262">
              Book Clubs
            </button>
            <button className="px-3 py-1 border border-gray-300 bg-gray-200 rounded-full text-sm" data-id="element-2263">
              Hiking Groups
            </button>
            <button className="px-3 py-1 border border-gray-300 bg-gray-200 rounded-full text-sm" data-id="element-2264">
              Movies & Shows
            </button>
            <button className="px-3 py-1 border border-gray-300 bg-gray-200 rounded-full text-sm" data-id="element-2265">
              Job Opportunities
            </button>
          </div>
          <StatisticsBar data-id="element-2266" />
        </div>
      </div>
      <div className="flex-1 p-4 max-w-4xl mx-auto w-full" data-id="element-2267">
        {/* Personalized Dashboard Section */}
        <PersonalizedSection data-id="element-2268" />
        <SocialTrendingSection data-id="element-2269" />
        {/* Featured Blog Content */}
        <div className="mt-8 mb-8" data-id="element-2270">
          <div className="flex justify-between items-center mb-4" data-id="element-2271">
            <h2 className="text-xl font-bold" data-id="element-2272">Featured Articles</h2>
            <button className="text-sm border border-gray-300 rounded-md px-3 py-1 hover:bg-gray-50" data-id="element-2273">
              View All
            </button>
          </div>
          {isLoading ? <SkeletonLoader type="article" count={2} grid data-id="element-2274" /> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2275">
              <div className="border border-gray-300 rounded-lg overflow-hidden" data-id="element-2276">
                <div className="h-40 bg-gray-200 border-b border-gray-300 relative" data-id="element-2277">
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-2278">
                    <span className="text-gray-500" data-id="element-2279">Running Image</span>
                  </div>
                </div>
                <div className="p-4" data-id="element-2280">
                  <span className="text-xs text-green-700 font-medium" data-id="element-2281">
                    COMMUNITIES
                  </span>
                  <h3 className="font-bold text-lg mt-1" data-id="element-2282">
                    Top 5 Running Clubs for Beginners in Nairobi
                  </h3>
                  <p className="text-sm text-gray-600 mt-2 line-clamp-2" data-id="element-2283">
                    Looking to start running but don't know where to begin?
                    These five running communities welcome beginners with open
                    arms and structured programs.
                  </p>
                  <div className="flex justify-between items-center mt-3" data-id="element-2284">
                    <span className="text-xs text-gray-500" data-id="element-2285">May 15, 2023</span>
                    <button className="text-sm text-green-700 hover:underline" data-id="element-2286">
                      Read More
                    </button>
                  </div>
                </div>
              </div>
              <div className="border border-gray-300 rounded-lg overflow-hidden" data-id="element-2287">
                <div className="h-40 bg-gray-200 border-b border-gray-300 relative" data-id="element-2288">
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-2289">
                    <span className="text-gray-500" data-id="element-2290">Networking Image</span>
                  </div>
                </div>
                <div className="p-4" data-id="element-2291">
                  <span className="text-xs text-green-700 font-medium" data-id="element-2292">
                    CAREER
                  </span>
                  <h3 className="font-bold text-lg mt-1" data-id="element-2293">
                    How to Make the Most of a Tech Meetup
                  </h3>
                  <p className="text-sm text-gray-600 mt-2 line-clamp-2" data-id="element-2294">
                    Tech meetups are more than just presentations. Learn how to
                    network effectively, ask the right questions, and follow up
                    with new connections.
                  </p>
                  <div className="flex justify-between items-center mt-3" data-id="element-2295">
                    <span className="text-xs text-gray-500" data-id="element-2296">June 2, 2023</span>
                    <button className="text-sm text-green-700 hover:underline" data-id="element-2297">
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>}
        </div>
        <div className="flex justify-between items-center mt-8 mb-4" data-id="element-2298">
          <h2 className="text-xl font-bold flex items-center" data-id="element-2299">
            <TrendingUpIcon className="w-5 h-5 mr-2" data-id="element-2300" />
            Popular Communities
          </h2>
          <button className="text-sm border border-gray-300 rounded-md px-3 py-1" data-id="element-2301">
            See All
          </button>
        </div>
        {isLoading ? <SkeletonLoader type="community" count={4} grid data-id="element-2302" /> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2303">
            {recommendedCommunities.map(community => <CommunityCard key={community.id} {...community} data-id="element-2304" />)}
          </div>}
        <div className="mt-8 mb-4" data-id="element-2305">
          <div className="flex justify-between items-center mb-2" data-id="element-2306">
            <h2 className="text-xl font-bold flex items-center" data-id="element-2307">
              <MapPinIcon className="w-5 h-5 mr-2" data-id="element-2308" />
              Communities Near You
            </h2>
            <button className="text-sm border border-gray-300 rounded-md px-3 py-1" data-id="element-2309">
              See All
            </button>
          </div>
          {isLoading ? <SkeletonLoader type="community" count={2} grid data-id="element-2310" /> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2311">
              {recommendedCommunities.slice(0, 2).map(community => <CommunityCard key={community.id} {...community} data-id="element-2312" />)}
            </div>}
        </div>
        <div className="mt-8 mb-8" data-id="element-2313">
          <div className="flex justify-between items-center mb-4" data-id="element-2314">
            <h2 className="text-xl font-bold flex items-center" data-id="element-2315">
              <CalendarIcon className="w-5 h-5 mr-2" data-id="element-2316" />
              Upcoming Events
            </h2>
            <Link to="/events" className="text-sm border border-gray-300 rounded-md px-3 py-1" data-id="element-2317">
              View All Events
            </Link>
          </div>
          {isLoading ? <SkeletonLoader type="event" count={2} grid data-id="element-2318" /> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2319">
              <EventCard title="Venture Wars" date="Aug 20, 2023" time="6:00 PM - 9:00 PM" location="Nairobi Garage, Westlands" attendees={42} maxAttendees={100} data-id="element-2320" />
              <EventCard title="Yoga In The Park" date="Aug 10, 2023" time="7:00 AM - 8:30 AM" location="Uhuru Park, Nairobi" attendees={28} maxAttendees={50} data-id="element-2321" />
            </div>}
        </div>
        <div className="mt-8 mb-8" data-id="element-2322">
          <div className="flex justify-between items-center mb-4" data-id="element-2323">
            <h2 className="text-xl font-bold flex items-center" data-id="element-2324">
              <FilmIcon className="w-5 h-5 mr-2" data-id="element-2325" />
              Latest Movies & Shows
            </h2>
            <Link to="/movies" className="text-sm border border-gray-300 rounded-md px-3 py-1" data-id="element-2326">
              View All Movies
            </Link>
          </div>
          {isLoading ? <SkeletonLoader type="movie" count={2} grid data-id="element-2327" /> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2328">
              <div className="border border-gray-300 rounded-lg overflow-hidden" data-id="element-2329">
                <div className="h-40 bg-gray-200 border-b border-gray-300 relative" data-id="element-2330">
                  <img src="https://m.media-amazon.com/images/M/MV5BODI0YjNhNjUtYjM0My00MTUwLWFlYTMtMWI2NGUzYjNjNGQzXkEyXkFqcGdeQXVyMDM2NDM2MQ@@._V1_.jpg" alt="Dune: Part Two" className="w-full h-full object-cover" data-id="element-2331" />
                </div>
                <div className="p-3" data-id="element-2332">
                  <h3 className="font-bold" data-id="element-2333">Dune: Part Two</h3>
                  <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-2334">
                    <span className="bg-gray-200 px-2 py-0.5 rounded text-xs mr-2" data-id="element-2335">
                      IMDb: 8.8
                    </span>
                    <span className="bg-gray-200 px-2 py-0.5 rounded text-xs" data-id="element-2336">
                      Rotten Tomato: 92%
                    </span>
                  </div>
                  <div className="mt-2 flex justify-between items-center" data-id="element-2337">
                    <Link to="/movies" className="text-xs bg-green-700 text-white px-3 py-1 rounded-md" data-id="element-2338">
                      Buy Ticket
                    </Link>
                  </div>
                </div>
              </div>
              <div className="border border-gray-300 rounded-lg overflow-hidden" data-id="element-2339">
                <div className="h-40 bg-gray-200 border-b border-gray-300 relative" data-id="element-2340">
                  <img src="https://m.media-amazon.com/images/M/MV5BYzI0YjYxY2UtNzRkNS00MmZhLTkzNzMtODk4Y2M3MmE4NGJkXkEyXkFqcGdeQXVyMTUzMTg2ODkz._V1_.jpg" alt="Kung Fu Panda 4" className="w-full h-full object-cover" data-id="element-2341" />
                </div>
                <div className="p-3" data-id="element-2342">
                  <h3 className="font-bold" data-id="element-2343">Kung Fu Panda 4</h3>
                  <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-2344">
                    <span className="bg-gray-200 px-2 py-0.5 rounded text-xs mr-2" data-id="element-2345">
                      IMDb: 7.3
                    </span>
                    <span className="bg-gray-200 px-2 py-0.5 rounded text-xs" data-id="element-2346">
                      Rotten Tomato: 84%
                    </span>
                  </div>
                  <div className="mt-2 flex justify-between items-center" data-id="element-2347">
                    <Link to="/movies" className="text-xs bg-green-700 text-white px-3 py-1 rounded-md" data-id="element-2348">
                      Buy Ticket
                    </Link>
                  </div>
                </div>
              </div>
            </div>}
        </div>
        <div className="mt-8" data-id="element-2349">
          <div className="flex justify-between items-center mb-4" data-id="element-2350">
            <h2 className="text-xl font-bold flex items-center" data-id="element-2351">
              <BriefcaseIcon className="w-5 h-5 mr-2" data-id="element-2352" />
              Featured Job Opportunities
            </h2>
            <Link to="/jobs" className="text-sm border border-gray-300 rounded-md px-3 py-1" data-id="element-2353">
              View All Jobs
            </Link>
          </div>
          {isLoading ? <SkeletonLoader type="job" count={2} grid data-id="element-2354" /> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2355">
              <div className="border border-gray-300 rounded-lg p-4" data-id="element-2356">
                <h3 className="font-bold" data-id="element-2357">Software Developer</h3>
                <p className="text-sm text-gray-600 mt-1" data-id="element-2358">
                  Tech Innovations Kenya • Nairobi
                </p>
                <div className="flex items-center mt-2 text-xs text-gray-500" data-id="element-2359">
                  <span className="bg-gray-200 px-2 py-0.5 rounded" data-id="element-2360">
                    Full-time
                  </span>
                  <span className="mx-2" data-id="element-2361">•</span>
                  <span data-id="element-2362">KES 100,000 - 150,000</span>
                </div>
                <div className="mt-3" data-id="element-2363">
                  <Link to="/jobs" className="text-xs border border-gray-300 rounded-md px-2 py-1 hover:bg-gray-50" data-id="element-2364">
                    Apply Now
                  </Link>
                </div>
              </div>
              <div className="border border-gray-300 rounded-lg p-4" data-id="element-2365">
                <h3 className="font-bold" data-id="element-2366">Marketing Manager</h3>
                <p className="text-sm text-gray-600 mt-1" data-id="element-2367">
                  Growth Strategies Ltd • Mombasa
                </p>
                <div className="flex items-center mt-2 text-xs text-gray-500" data-id="element-2368">
                  <span className="bg-gray-200 px-2 py-0.5 rounded" data-id="element-2369">
                    Full-time
                  </span>
                  <span className="mx-2" data-id="element-2370">•</span>
                  <span data-id="element-2371">KES 120,000 - 180,000</span>
                </div>
                <div className="mt-3" data-id="element-2372">
                  <Link to="/jobs" className="text-xs border border-gray-300 rounded-md px-2 py-1 hover:bg-gray-50" data-id="element-2373">
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>}
        </div>
        {/* Brands That Trust Us */}
        <BrandsTrustUs data-id="element-2374" />
      </div>
    </div>;
};
export default Home;